var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingActive),expression:"loadingActive"}],ref:"imageContainer",attrs:{"id":"imageContainer","element-loading-text":"拼命加载中"}},[_c('img',{ref:"viewerDom",staticClass:"imageClass",attrs:{"src":"","alt":""},on:{"load":_vm.imageLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }